import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3476fead"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "engineer-status-container f1 fv hidden" }
const _hoisted_2 = {
  class: "fh-s-b",
  style: {"height":"8.33%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "未解决工单", -1))
const _hoisted_4 = {
  class: "f1",
  style: {"height":"calc(81.67% - 16px)","margin-top":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menuItem = _resolveComponent("a-menuItem")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_VirtualColumnVue = _resolveComponent("VirtualColumnVue")!
  const _component_VirtualTableVue = _resolveComponent("VirtualTableVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_dropdown, { style: {"width":"200px"} }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { class: "menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTime('THIS_WEEK')))
                  }, "本周")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTime('THIS_MONTH')))
                  }, "本月")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTime('THIS_YEAR')))
                  }, "本年")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "fs12 color-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(_ctx.timeFilter(_ctx.timeRef)), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_VirtualTableVue, {
        data: _ctx.data,
        openVirtual: "",
        style: {"width":"100%","height":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VirtualColumnVue, {
            prop: "ticketNo",
            width: "60",
            label: "工单编号"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "userName",
            width: "80",
            label: "客户"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "engineerName",
            width: "100",
            label: "客服"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "serviceCatalogName",
            width: "120",
            label: "服务目录"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}